import { Layer } from "@carbon/react";
import { FC, JSX } from "react";

import { Drawer } from "src/components/Modal";
import { useT } from "src/internationalization";

import { GRAPH_SIDE_PANEL_WIDTH_REM } from "../graph.constants";
import { GraphIdentifierNodeData } from "../graph.types.ts";

type GraphIdentifierNodePassiveModalProps = {
  data: GraphIdentifierNodeData;
  onClose: () => void;
};

export const GraphIdentifierNodePassiveModal: FC<GraphIdentifierNodePassiveModalProps> = ({
  data: { label, element },
  onClose,
}): JSX.Element => {
  const t = useT();

  return (
    <Drawer
      layer={2}
      width={`${GRAPH_SIDE_PANEL_WIDTH_REM}rem`}
      className="[&_.cds--modal-content]:overflow-y-hidden"
      title={label}
      subtitle={element}
      onClose={onClose}
      closeOnOutsideClick={false}
    >
      <Layer level={1} className="h-full overflow-hidden flex flex-col">
        {t("general.empty")}
      </Layer>
    </Drawer>
  );
};
